export enum Length {
    cm = 'cm',
    ft = 'ft',
    in = 'in',
    m = 'm',
    mm = 'mm',
    yd = 'yd',
}
